import React, { useState } from 'react';
import './Reset-password.scss';
import logo from '../../assets/OHM_1.png';
import { useNavigate } from 'react-router-dom';
import { api } from '../../Api-Endpoints/apiEndpoint';
import toast from 'react-hot-toast';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const handleResetPasswordClick = async () => {
    try {
      const { status, data } = await api.post('/admin/admin-reset-password', {
        email,
      });
      if (status == 200 && data.success) {
        toast.success(data.msg);
        // navigate('/reset-new-password');
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const handleSigninClick = () => {
    navigate('/login');
  };
  return (
    <>
      <div className="loginSignUp">
        <div className="main">
          <div className="left">
            <div className="image">
              <img src={logo} alt="logo" />
            </div>
            <div className="heading-sighin">
              <p>Reset</p>
            </div>
            <div className="input-feild">
              <input
                type="text"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="E-mail"
              />
            </div>
            <div className="buttens">
              <button className="login-btn" onClick={handleResetPasswordClick}>
                Send Reset Instruction
              </button>
              <button className="fp-btn" onClick={handleSigninClick}>
                Sign In
              </button>
            </div>
          </div>
          <div className="right">
            <div className="head-text-combine">
              <div className="heading-welcome">
                <p>Forgot Password?</p>
              </div>
              <div className="text-for-welcome">
                <p>
                  please putt your Email in the left given box with which you
                  last register your account.we will send you the new password{' '}
                  <br />
                  <br />
                  please check your email inbox for login detail.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
